/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Settings_Template_Audience_Only_CohortInputs */



/**
* | output |
* | --- |
* | "Only group: {title}" |
*
* @param {Settings_Template_Audience_Only_CohortInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_only_cohort = /** @type {((inputs: Settings_Template_Audience_Only_CohortInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_Only_CohortInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Alleen groep: ${i?.title}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Seulement le groupe : ${i?.title}`)
	return /** @type {LocalizedString} */ (`Only group: ${i?.title}`)
});